import { render, staticRenderFns } from "./TableSales.vue?vue&type=template&id=7e34b14a&scoped=true&"
import script from "./TableSales.vue?vue&type=script&lang=js&"
export * from "./TableSales.vue?vue&type=script&lang=js&"
import style0 from "./TableSales.vue?vue&type=style&index=0&id=7e34b14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e34b14a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
